/**
 * Magna Flavor Highlight
 * Handles flavor pill navigation and image slide transitions.
 */
(function () {
  'use strict';

  const section = document.querySelector('[data-magna-flavor-highlight]');
  if (!section) return;

  const pills = section.querySelectorAll('.magna-flavor-highlight__pill');
  const slides = section.querySelectorAll('.magna-flavor-highlight__slide');

  if (!pills.length || !slides.length) return;

  pills.forEach((pill) => {
    pill.addEventListener('click', () => {
      const index = parseInt(pill.dataset.flavorIndex, 10);

      // Update pills
      pills.forEach((p) => p.classList.remove('is-active'));
      pill.classList.add('is-active');

      // Update slides
      slides.forEach((s) => s.classList.remove('is-active'));
      const targetSlide = section.querySelector(
        `.magna-flavor-highlight__slide[data-slide-index="${index}"]`
      );
      if (targetSlide) targetSlide.classList.add('is-active');
    });
  });
})();
